import _Menu from "@material-ui/core/esm/Menu";
import _MenuItem from "@material-ui/core/esm/MenuItem";
import _Link from "@material-ui/core/esm/Link";
import React, { useState } from 'react';
import classnames from 'classnames';
import { browserHistory } from 'react-router';
import downArrowIcon from 'assets/svg/angle-arrow-down-white.svg';
import { handleClick } from 'swag-client-common/components/ecommerce-header/components/offers-dropdown/on-click-function';
import { handleOnEnterPressed } from 'swag-client-common/utils/ui.utils';
import classes from './offers-dropdown.scss';
import { anchorOrigin } from './offers-dropdown.constants';
const menuClasses = {
  paper: classes.dropdownPaperWrapper,
  list: classes.menu
};
const linkClasses = {
  root: classes.whatWeOfferLink
};
export const OffersDropdownComponent = ({
  offerOptions,
  isShown,
  hubspotCalendarLink,
  openRequestDemoPopup
}) => {
  if (!isShown) {
    return null;
  }
  const [anchorEl, setAnchorEl] = useState(null);
  const wrappedClickHandler = e => handleClick(setAnchorEl)(e);
  const hideDropdown = () => setAnchorEl(null);
  const handleMenuItemClick = (link, isCurrentPath) => () => {
    hideDropdown();
    if (!isCurrentPath) {
      browserHistory.push(link);
    }
  };
  const handleOpenRequestDemo = () => {
    hideDropdown();
    if (!hubspotCalendarLink) {
      openRequestDemoPopup();
    }
  };
  const openCalendarLink = () => {
    if (hubspotCalendarLink) {
      window.open(hubspotCalendarLink, '_blank');
      hideDropdown();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Link, {
    component: "button",
    classes: linkClasses,
    onClick: wrappedClickHandler
  }, "What We Offer", /*#__PURE__*/React.createElement("img", {
    className: classes.downArrowIcon,
    src: downArrowIcon,
    alt: "White arrow pointing downwards"
  })), /*#__PURE__*/React.createElement(_Menu, {
    keepMounted: true,
    anchorEl: anchorEl,
    anchorOrigin: anchorOrigin,
    open: Boolean(anchorEl),
    getContentAnchorEl: null,
    onClose: hideDropdown,
    classes: menuClasses
  }, offerOptions.map(({
    title,
    description,
    link,
    color,
    isActive,
    isCurrentPath
  }) => /*#__PURE__*/React.createElement(_MenuItem, {
    className: classnames(classes.menuItem, classes[color], {
      [classes.active]: isActive
    }),
    key: link,
    onClick: handleMenuItemClick(link, isCurrentPath)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.horizontalLine
  }), /*#__PURE__*/React.createElement("span", null, title, "\xA0"), "- ", description)), /*#__PURE__*/React.createElement(_MenuItem, {
    onClick: handleOpenRequestDemo,
    className: classes.requestDemoOption,
    onKeyDown: e => handleOnEnterPressed(e, openCalendarLink)
  }, hubspotCalendarLink ? /*#__PURE__*/React.createElement("a", {
    href: hubspotCalendarLink,
    target: "_blank",
    rel: "noreferrer"
  }, "Want to chat? Request a Demo") : 'Want to chat? Request a Demo')));
};